import { Component } from "@angular/core";
import { ReactiveFormsModule, Validators } from "@angular/forms";
import { MatRadioModule } from "@angular/material/radio";
import { ExtraPropertiesFieldComponent } from "../../extra-properties-field.component";

@Component({
  selector: "app-extra-properties-referrer",
  standalone: true,
  imports: [MatRadioModule, ReactiveFormsModule],
  templateUrl: "./extra-properties-referrer.component.html",
  styleUrl: "./extra-properties-referrer.component.less",
})
export class ExtraPropertiesReferrerComponent extends ExtraPropertiesFieldComponent<string> {
  public options: string[];

  public constructor() {
    super();
    this.key = "referrer";
    this.options = [
      "Brief van de gemeente",
      "Lokale energiemarkt",
      "Drents Energieloket",
      "Advertentie in de krant",
      "Sociale media ",
      "Mond-tot-mondreclame",
      "Flyer (aan de deur / in de brievenbus)",
      "Flyer van buurt- of wijkcentrum",
    ];
    this.control.addValidators(Validators.required);
  }
}
